<script setup>
const emit = defineEmits(['redirectToLogin'])
const { t } = useI18n()
</script>

<template>
  <div class="flex grow flex-col justify-between flex-gap-y-4 whitespace-pre-wrap">
    <DSAlert
      type="info"
      no-close
      class="w-100%"
    >
      {{ t('Please login or signup to start booking') }}
    </DSAlert>
    <div
      class="flex flex-col items-center flex-gap-y-2"
    >
      <DSButton
        class="btn btn-md w-full uppercase btn-fill-primary"
        @click="emit('redirectToLogin')"
      >
        <span>{{ t('Login or Signup') }}</span>
      </DSButton>
    </div>
  </div>
</template>

<i18n>
{
  "en-us": {
    "Contact Us": "Contact Us",
    "Please login or signup to start booking": "Please login or signup to start booking",
    "Login or Signup": "Login or Signup"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Contact Us": "Kontaktieren Sie uns",
  "Login or Signup": "Einloggen oder Registrieren",
  "Please login or signup to start booking": "Bitte logge dich ein oder registriere dich, um mit der Buchung zu beginnen."
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Contact Us": "Nous contacter",
  "Please login or signup to start booking": "Veuillez vous connecter ou créer un compte pour commencer à réserver",
  "Login or Signup": "Connexion ou inscription"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Contact Us": "Contactarnos",
  "Please login or signup to start booking": "Por favor, inicia sesión o regístrate para empezar a reservar",
  "Login or Signup": "Iniciar sesión o registrarse"
}
</i18n>
